import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const UsuarioCursoRow=({usuariocurso, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{usuariocurso.correo}</Table.Cell>
                        <Table.Cell>{usuariocurso.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{usuariocurso.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/usuariocurso/"+usuariocurso.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(usuariocurso.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={usuariocurso.idEstatus==1?'x':'check'} link  size="large" 
                                                color={usuariocurso.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(usuariocurso.id)} 
                                            />
                                        }
                                        content={usuariocurso.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default UsuarioCursoRow;